export enum TableMode {
  LIST,
  THUMBNAIL,
}
